import { render, staticRenderFns } from "./loginOtp.vue?vue&type=template&id=ac5ed458&scoped=true&"
import script from "./loginOtp.vue?vue&type=script&lang=js&"
export * from "./loginOtp.vue?vue&type=script&lang=js&"
import style0 from "./loginOtp.vue?vue&type=style&index=0&id=ac5ed458&lang=sass&scoped=true&"
import style1 from "./loginOtp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5ed458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VBtn,VCard,VFlex,VForm,VIcon,VLayout,VProgressLinear,VSnackbar})
